export default "__VITE_ASSET__39OX0Mp7__"